import {isLocalProfile} from '@web/core/config'

/** 주문 정보 복원 끄기 */
export const NO_STORAGE_ON_REFRESH = isLocalProfile && false
